import * as React from 'react'
import Box from '@mui/joy/Box/index'
import Button from '@mui/joy/Button/index'
import FormControl from '@mui/joy/FormControl/index'
import Textarea from '@mui/joy/Textarea'
import { Stack } from '@mui/joy'

import SendRoundedIcon from '@mui/icons-material/SendRounded'

export default function MessageInput({
  textAreaValue,
  setTextAreaValue,
  onSubmit,
  disabled = false,
}) {
  const textAreaRef = React.useRef(null)
  const handleClick = () => {
    if (textAreaValue.trim() !== '' && !disabled) {
      onSubmit()
      setTextAreaValue('')
    }
  }
  return (
    <Box sx={{ px: 2, pb: 3 }}>
      <FormControl>
        <Textarea
          placeholder={
            disabled ?
              "Input disabled for other user's conversation..."
            : 'Type something here…'
          }
          aria-label="Message"
          ref={textAreaRef}
          onChange={(e) => {
            if (!disabled) {
              setTextAreaValue(e.target.value)
            }
          }}
          value={textAreaValue}
          minRows={3}
          maxRows={10}
          disabled={disabled}
          sx={{
            '& textarea:first-of-type': {
              minHeight: 72,
            },
            ...(disabled && {
              opacity: 0.7,
              cursor: 'not-allowed',
            }),
          }}
          endDecorator={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexGrow={1}
              sx={{
                py: 1,
                pr: 1,
                borderTop: '1px solid',
                borderColor: 'divider',
              }}
            >
              <div>
                {disabled ? 'Input disabled' : '(Ctrl/Cmd + Enter to send)'}
              </div>
              <Button
                size="sm"
                color="primary"
                sx={{ alignSelf: 'center', borderRadius: 'sm' }}
                endDecorator={<SendRoundedIcon />}
                onClick={handleClick}
                disabled={disabled}
              >
                Send
              </Button>
            </Stack>
          }
          onKeyDown={(event) => {
            if (
              !disabled &&
              event.key === 'Enter' &&
              (event.metaKey || event.ctrlKey)
            ) {
              handleClick()
            }
          }}
        />
      </FormControl>
    </Box>
  )
}
